import * as io from 'io-ts';

export const number = io.number;
export const nullableNumber = io.union([io.number, io.null]);
